import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';

import { Flexible } from '../../../shared/interfaces/create-surveys.interface';
import { SelectedQuota } from '../../../shared/interfaces/quota.interface';
import { QuotaModalService } from '../quota-modal.service';
import { QUALIFICATION_CODES } from '../../../shared/constants/qualification-code';

@Component({
  selector: 'ps-ui-multiselect-quota-row',
  templateUrl: './multiselect-quota-row.component.html',
  styleUrls: ['./multiselect-quota-row.component.css'],
})
export class MultiselectQuotaRowComponent implements OnInit, OnChanges {
  @Input() data!: any;
  @Input() flexible!: Flexible;
  @Output() readonly quotasChanged = new EventEmitter();
  quotas = this.data?.quotas || this._fb.array([]);
  zipcodeQualificationCode = QUALIFICATION_CODES.ZIPCODE;

  form = this._fb.group({
    quotas: this.quotas,
  });

  constructor(
    private _fb: FormBuilder,
    private _quotaModalService: QuotaModalService
  ) {}

  ngOnInit(): void {
    this._initForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data?.currentValue?.quotas?.length) {
      this._updateQuotaRow(changes.data.currentValue.quotas);
    }

    if (changes.flexible?.currentValue) {
      this.flexible = changes.flexible.currentValue;
    }
  }

  private _initForm() {
    const quotas = this.data?.quotas?.length
      ? this.data.quotas
      : this.data.qualification.data;
    this._createQuotaRow(quotas);
  }

  private _createQuotaRow(quotas: SelectedQuota[]) {
    let control: FormArray = <FormArray>this.form.get('quotas');

    if (quotas.length) {
      control.controls = [];
      this._createRowForm(control, quotas);
    }
    this.quotasChanged.emit(this.form.value.quotas);
  }

  private _createRowForm(control: FormArray, quotas: SelectedQuota[]) {
    quotas.forEach((quota: SelectedQuota) => {
      if (quota.selected) {
        let rowForm = this._fb.group({
          buyer_quota_id: [quota.buyer_quota_id || ''],
          selected: [quota.selected || true],
          selectedForGroup: [quota.selectedForGroup || false],
          oldQuotasText: [quota.oldQuotasText || []],
          text: [quota.text, Validators.required],
          group_name: [quota.group_name],
          options: [quota.options || []],
          number: [Number(quota.number) || null, Validators.required],
          percentage: [Number(quota.percentage) || null, Validators.required],
          minimum: [
            quota.minimum === undefined ? null : Number(quota.minimum),
            Validators.required,
          ],
          maximum: [
            quota.maximum === undefined ? null : Number(quota.maximum),
            Validators.required,
          ],
          suppliers: [quota.suppliers || []],
        });
        control.push(rowForm);
      }
    });
  }

  private _updateQuotaRow(updateQuotas: SelectedQuota[]) {
    this.data.quotas = updateQuotas;
    const control: FormArray = <FormArray>this.form.get('quotas');
    if (control.controls.length) {
      updateQuotas.forEach((_quota: SelectedQuota, index: number) => {
        control.controls[index].patchValue(_quota);
      });
    }
  }

  numberChange(event: Event, index: number) {
    let requiredCount = Number((<HTMLInputElement>event.target).value);
    const control: FormArray = <FormArray>this.form.get('quotas');

    if (
      this._quotaModalService.isValidAllocation(
        this.data.complete,
        control,
        index
      )
    ) {
      let [minimum, maximum] = this._quotaModalService.getFlexibleValue(
        requiredCount,
        this.flexible
      );
      control.controls[index].patchValue({
        percentage: Math.round(
          (requiredCount * 100) / Number(this.data.complete)
        ),
        minimum: minimum,
        maximum: maximum,
      });
    }

    this.quotasChanged.emit(this.form.value.quotas);
  }

  percentageChange(event: Event, index: number) {
    let value = Number((<HTMLInputElement>event.target).value);
    const control: FormArray = <FormArray>this.form.get('quotas');

    if (
      this._quotaModalService.isValidAllocation(
        this.data.complete,
        control,
        index
      )
    ) {
      const number = this._quotaModalService.getNumber(
        this.data.complete,
        this.form.value.quotas,
        value,
        index
      );
      let [minimum, maximum] = this._quotaModalService.getFlexibleValue(
        number,
        this.flexible
      );
      control.controls[index].patchValue({
        number: number,
        minimum: minimum,
        maximum: maximum,
      });
    }

    this.quotasChanged.emit(this.form.value.quotas);
  }

  public ungroupQuota(quotas: SelectedQuota) {
    const found = this.data?.quotas.some(
      (quota: SelectedQuota) => quota.text === quotas.text
    );
    let ungroupQuota: SelectedQuota[] = [];
    let quotaOptionArray = quotas.oldQuotasText;

    quotaOptionArray?.forEach((singleText: string) => {
      ungroupQuota.push({
        maximum: 0,
        minimum: 0,
        number: 0,
        percentage: 0,
        selected: true,
        selectedForGroup: false,
        text: singleText,
        oldQuotasText: [singleText],
      });
    });

    if (!found) {
      quotas.selectedForGroup = true;
      quotas.selected = true;
    } else if (found) {
      this.data.quotas = this.data?.quotas.filter(
        (quota: SelectedQuota) => quota.text !== quotas.text
      );
      this.data?.quotas.map((data: SelectedQuota) => {
        data.selected = true;
        return data;
      });
    }
    const quotaRows = [...this.data?.quotas, ...ungroupQuota];
    this._createQuotaRow(quotaRows);
  }
}
